/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_Frame_AltInputs */

const en_mk_studio_frame_alt = /** @type {(inputs: Mk_Studio_Frame_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep client page: progress per feature with an evidence bar and an Approve-phase button`)
};

const id_mk_studio_frame_alt = /** @type {(inputs: Mk_Studio_Frame_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman klien Bystep: progres per fitur dengan bar bukti dan tombol Setujui fase`)
};

/**
* | output |
* | --- |
* | "Bystep client page: progress per feature with an evidence bar and an Approve-phase button" |
*
* @param {Mk_Studio_Frame_AltInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_frame_alt = /** @type {((inputs?: Mk_Studio_Frame_AltInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_Frame_AltInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_frame_alt(inputs)
	return en_mk_studio_frame_alt(inputs)
});